export default (editor, opts = {}) => {
  const block = {
    label: "Formulário Cubo",
    content: { type: "formNew" },
    category: "Formulários",
    fromPlugin: 'basic',
    media: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 1080 1080">
  <path style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-dashoffset:0;stroke-linejoin:miter;stroke-miterlimit:4;fill:#2253f5;fill-rule:evenodd;opacity:1" vector-effect="non-scaling-stroke" transform="matrix(5.19 0 0 5.19 89.664 32.937)" d="M94.83 2.16a16.12 16.12 0 0 0-16.12 0L8.06 43A16.11 16.11 0 0 0 0 56.91v81.59a16.11 16.11 0 0 0 8.06 13.95l70.65 40.79a16.12 16.12 0 0 0 16.12 0l70.65-40.79a16.11 16.11 0 0 0 8.06-13.95V56.91a16.11 16.11 0 0 0-8.06-14ZM92 100.45v42.89a5.7 5.7 0 0 1-3.46 5.3 5.65 5.65 0 0 1-6.23-1.26 5.69 5.69 0 0 1-1.61-4l-.05-42.91L44.2 78.13a5.652 5.652 0 0 1 4.68-10.29l.25.12L86.4 90.5l37.75-22.61.21-.08a5.66 5.66 0 0 1 7.38 3 5.61 5.61 0 0 1 .44 2.17 5.78 5.78 0 0 1-.42 2.17 5.68 5.68 0 0 1-2.8 3Z"/>
</svg>
    `,
  };
  return block;
};